import React, { Fragment, useEffect, useLayoutEffect, useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import styles from "./styles/MainHeader.module.css";
import { Link, useNavigate } from "react-router-dom";
import { Button, Stack } from "react-bootstrap";
import { AccessControl, AvatarPopup } from "@components";
import { ADMIN_ROLE, INSTRUCTOR_ROLE, STUDENT_ROLE } from "@constants";
import { ReactComponent as Logo } from "@assets/svgs/logo.svg";
import { useDispatch, useSelector } from "react-redux";
import { useWindowSize } from "@hooks";
import { getCartAction } from "@redux/actions";

const MainHeader = ({ toggleMenu }) => {
  // state
  const [shortcutVisible, setShortcutVisible] = useState(false);

  // variables
  let personalShortcut = null;

  // logics before hooks

  // hooks
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { width } = useWindowSize();
  const { login } = useSelector((state) => state.auth);
  const { isAuth, role } = login;
  const { allCart } = useSelector((state) => state.orders);

  // logics

  // UI partials
  if (shortcutVisible)
    personalShortcut = (
      <Fragment>
        <AccessControl targetRoles={[INSTRUCTOR_ROLE]}>
          <Button onClick={() => navigate("/create-new-course")}>
            Create New Course
          </Button>
        </AccessControl>
        <AccessControl targetRoles={[INSTRUCTOR_ROLE, STUDENT_ROLE]}>
          <Button onClick={() => navigate("/my-learning")}>My Learning</Button>
        </AccessControl>
      </Fragment>
    );

  const leftSideUI = (
    <Stack direction="horizontal" gap={2}>
      <Button
        variant={width > 768 ? "primary" : "light"}
        className={styles.toggleButton}
        onClick={toggleMenu}
      >
        <i className="fa-solid fa-bars" />
      </Button>
      <Link to={role === ADMIN_ROLE ? "/admin" : "/"}>
        <Logo width={width < 375 ? 100 : 120} />
      </Link>
    </Stack>
  );

  let rightSideUI = (
    <Stack direction="horizontal" gap={2} className="mr-3">
      <Button onClick={() => navigate("/sign-in")}>Sign In</Button>
      <Button variant="outline-primary" onClick={() => navigate("/sign-up")}>
        Sign Up
      </Button>
    </Stack>
  );

  if (isAuth)
    rightSideUI = (
      <Stack direction="horizontal" gap={2}>
        <AccessControl targetRoles={[STUDENT_ROLE, INSTRUCTOR_ROLE]}>
          <Fragment>
            {personalShortcut}
            <Link
              className={clsx(styles.link, styles.linkCart)}
              to={"/shopping-cart"}
            >
              <i
                className={clsx("bi bi-cart3")}
                // className={clsx("bi bi-cart3", {
                //   [styles.badge]: !allCart.data && allCart.data.length > 0,
                // })}
                // value={allCart.data ? allCart.data.length : null}
              />
              {allCart.data && allCart.data.length > 0 ? (
                <span
                  className={clsx(styles.badge, {
                    [styles.badgeS]: allCart.data.length < 10,
                    [styles.badgeM]:
                      allCart.data.length < 100 && allCart.data.length >= 10,
                    // [styles.badgeS]: allCart.data.length < 10,
                  })}
                >
                  {allCart.data.length > 99 ? "99+" : allCart.data.length}
                  {/* {allCart.data.length > 99 ? "99+" : allCart.data.length} */}
                </span>
              ) : null}
            </Link>
            {/* <Link className={styles.link} to={"/"}>
              <i className="bi bi-bell" />
            </Link> */}
          </Fragment>
        </AccessControl>
        <AvatarPopup />
      </Stack>
    );

  // effects
  useLayoutEffect(() => {
    if (width > 768) setShortcutVisible(true);
    else setShortcutVisible(false);
  }, [width]);

  useEffect(() => {
    dispatch(getCartAction());
  }, []);

  // render
  return (
    <header
      className={clsx(
        styles.header,
        "fixed-top",
        "vw-100",
        "d-flex",
        "align-items-center",
        "justify-content-between"
      )}
    >
      {leftSideUI}
      {rightSideUI}
    </header>
  );
};

/* required: display name */
MainHeader.displayName = "MainHeader";

/* required: props types */
MainHeader.propTypes = { toggleMenu: PropTypes.func.isRequired };

/* required: default props */
MainHeader.defaultProps = { toggleMenu: () => {} };

export { MainHeader };
